export const SOCIAL_SHARE = 'social';
export const LINK_SHARE = 'link';
export const EMBED_SHARE = 'embed';